import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons"
import { Tag } from "antd"
import { type ReactNode } from "react"

import {
  TRYOUT_RESULT_LABELS,
  TRYOUT_RESULTS,
  type TryoutResult,
} from "#utils/tryoutHelpers"

const TAG_PROPS_BY_RESULT: Record<
  TryoutResult,
  { color: string; icon: ReactNode }
> = {
  [TRYOUT_RESULTS.PENDING]: { color: "default", icon: <MinusCircleOutlined /> },
  [TRYOUT_RESULTS.PASSED]: { color: "success", icon: <CheckCircleOutlined /> },
  [TRYOUT_RESULTS.FAILED]: { color: "error", icon: <CloseCircleOutlined /> },
}

/**
 * Pass / fail / pending badge for a tryout. Used by the Tryouts table Result
 * column and the TryoutProgressFormModal title so both read the same way.
 * Derive `result` with `getTryoutResult(step2.didPassTryout)`.
 */
const TryoutResultTag = ({ result }: { result: TryoutResult }) => {
  const { color, icon } = TAG_PROPS_BY_RESULT[result]

  return (
    <Tag
      color={color}
      icon={icon}
      style={{ margin: 0 }}
      data-testid="tryout-result-tag"
      data-result={result}
    >
      {TRYOUT_RESULT_LABELS[result]}
    </Tag>
  )
}

export default TryoutResultTag
